module.exports = __webpack_public_path__ + "img/button-left-TL.a5c40003.png";